'use strict';

const HTTP_STATUS = require('http-status-codes');

const appendListMethod = require('../appendListMethod');
const conversions = require('./conversions');
const countryCodes = require('./countryCodes');
const events = require('./events');
const fileTypes = require('./fileTypes');
const feeds = require('./feeds');
const generic = require('./generic');
const measurementSystems = require('./measurementSystems');
const ranks = require('./ranks');
const rewards = require('./rewards');
const sports = require('./sports');
const time = require('./time');
const users = require('./users');
const contextTypes = require('./accesses/contextTypes');
const permissions = require('./accesses/permissions');
const roles = require('./accesses/roles');
const segments = require('./segments');
const resourceTypes = require('./resourceTypes');
const challengeTypes = require('./challengeTypes');
const passwordComplexity = require('./passwordComplexity');


module.exports = {
  // Basic constants unsorted
  ...conversions,
  ...events,
  ...feeds,
  ...generic,
  ...rewards,
  ...time,
  ...users,

  // Constants in sub-categories
  CHALLENGE_TYPES: appendListMethod(challengeTypes),
  COUNTRY_CODES: appendListMethod(countryCodes),
  FILE_TYPES: appendListMethod(fileTypes),
  HTTP_STATUS,
  MEASUREMENT_SYSTEMS: appendListMethod(measurementSystems),
  SPORTS: appendListMethod(sports),
  RANKS: appendListMethod(ranks),
  RESOURCE_TYPES: appendListMethod(resourceTypes),
  CONTEXT_TYPES: appendListMethod(contextTypes),
  PERMISSIONS: appendListMethod(permissions),
  ROLES: appendListMethod(roles),
  SEGMENTS: segments,
  PASSWORD_COMPLEXITY: passwordComplexity,
};
